export const initialState = {
 //add community post
 isContentTypeModalOpen:false,
 isAudienceModalOpen:false,
 ContentType:null,
 audienceTypes:null,
 isSubmitting:false,

}